<template>
  <v-date-picker
    v-model="picker"
    :color="color"
    landscape
    full-width
    class="mt-3 enrol-calendar"
    :allowed-dates="allowedDates"
    @input="selectDate"
    ></v-date-picker>
</template>
<script>
import { EventBus } from "@/event-bus.js";
export default {
  data() {
    return {
      picker: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().substr(0, 10)
    };
  },
  props: {
      color: {
      type: String,
      default: process.env.VUE_APP_PRIMARY_COLOR
    }
  },
  methods: {
    selectDate() {
      EventBus.$emit("DATE_SELECTED", this.picker);
    },
    allowedDates(val) {
      var date = new Date();
      return Date.parse(date) <= Date.parse(val) ? true : false;
    }
  }
};
</script>
